export default __webpack_public_path__ + "static/IBM-Plex-Mono-Italic-855a333e76f724107ca3595047d95081.woff";